import {
  FACompDetailsType,
  FACompResultDetailsType,
  FACompBlogContentType,
  FACompReferenceType,
  SponsorType,
} from "./../../types/blog/blogContentTypes";
import { FilterType } from "../../types/nlsCommon";
import { extractDate } from "../../common/utils";
import { BlogPostType } from "@nls-2022/nls-api";
import { FACompType } from "../../types/blog/blogContentTypes";
import {
  FACompsBySeasonDate,
  FAComps,
  Sponsors,
  FACompsResultBySeasonDate,
} from "../posts/postReferenceData";

export const filterDefaultCompBySeason = (
  season: string
): FACompReferenceType | null | undefined => {
  let comp = FACompsBySeasonDate.find((u) => u.season === season);
  if (comp === null || comp === undefined) {
    return null;
  }
  let compName = FAComps?.find(
    (u) => u.comp === comp!.compDetailsList[0].comp!
  )!.name;
  return FAComps.find((u) => u.name === compName);
};

export const filterDefaultRoundBySeasonAndComp = (
  season: string,
  comp: string | null | undefined
): FACompDetailsType | null | undefined => {
  let compBySeason = FACompsBySeasonDate.find((u) => u.season === season);
  if (compBySeason === null || compBySeason === undefined) {
    return null;
  }
  let foundComp = FAComps.find((u) => u.name === comp);
  if (foundComp === null || foundComp === undefined) return null;
  return compBySeason.compDetailsList.find((u) => u.comp === foundComp!.comp);
};

export const getFAComp = (
  compName: string
): FACompReferenceType | undefined => {
  return FAComps.find((u) => u.name === compName);
};
export const getFACompByType = (
  comp: FACompType
): FACompReferenceType | undefined => {
  return FAComps.find((u) => u.comp === comp);
};

export const getSponsorBySponsorName = (
  sponsorName: string
): SponsorType | undefined => {
  return Sponsors.find((u) => u.sponsorName === sponsorName);
};

export const filterCompRoundDetails = (
  season: string,
  compName: string,
  roundName: string
): FACompDetailsType | null => {
  let faComp = getFAComp(compName);
  if (faComp === null) return null;
  let seasonComp = FACompsBySeasonDate.find((u) => u.season === season);
  if (seasonComp === undefined) return null;
  let roundDetails = seasonComp.compDetailsList.find(
    (u) => u.comp === faComp!.comp && u.roundName === roundName
  );
  return roundDetails === undefined ? null : roundDetails;
};

export const filterCompResultDetails = (
  season: string,
  compName: string
): FACompResultDetailsType | null => {
  let faComp = getFAComp(compName);
  if (faComp === null) return null;
  let seasonComp = FACompsResultBySeasonDate.find((u) => u.season === season);
  if (seasonComp === undefined) return null;
  let resultDetails = seasonComp.compDetailsList.find(
    (u) => u.comp === faComp!.comp
  );
  return resultDetails === undefined ? null : resultDetails;
};
